import { ChapterShell } from "../ChapterShell";
import { FadeUp } from "../Reveal";

const PRINCIPLES = ["INSIGHT", "STRATEGY", "POSITIONING", "EXECUTION", "PEOPLE", "PATIENT", "GROWTH"];

export const ChapterTen = () => (
  <ChapterShell
    n="10"
    id="chapter-10"
    era="Beliefs"
    title="The Marketing Philosophy"
    quote="Great marketing connects insight with execution."
  >
    <FadeUp className="relative mx-auto flex h-[26rem] max-w-3xl items-center justify-center md:h-[30rem]">
      <div className="absolute inset-6 rounded-full border border-[#0A192F]/10 md:inset-2" />
      <div className="animate-orbit absolute inset-0">
        {PRINCIPLES.map((p, i) => {
          const angle = (i / PRINCIPLES.length) * 360;
          return (
            <div
              key={p}
              className="absolute left-1/2 top-1/2"
              style={{ transform: `rotate(${angle}deg) translateX(min(19vw, 13.5rem)) translate(-50%, -50%)` }}
            >
              <div className="animate-orbit-rev" style={{ transform: `rotate(${-angle}deg)` }}>
                <span className="glass inline-block rounded-full px-5 py-2.5 font-display text-xs font-black uppercase tracking-[0.2em] text-[#0A192F]">
                  {p}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      <div className="animate-glow relative z-10 flex h-44 w-44 items-center justify-center rounded-full bg-gradient-to-br from-[#0A192F] to-[#1B3A5C] text-center md:h-56 md:w-56">
        <p className="max-w-[9rem] font-display text-sm font-bold leading-snug text-white md:max-w-[11rem] md:text-base">
          Great marketing connects <span className="text-[#00E5FF]">insight</span> with{" "}
          <span className="text-[#00BFA5]">execution</span>
        </p>
      </div>
    </FadeUp>
  </ChapterShell>
);
